import { render } from "./DropdownInput.vue?vue&type=template&id=2b0d8738&scoped=true"
import script from "./DropdownInput.vue?vue&type=script&lang=js"
export * from "./DropdownInput.vue?vue&type=script&lang=js"

import "./DropdownInput.vue?vue&type=style&index=0&id=2b0d8738&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0d8738"]])

export default __exports__